import { render, staticRenderFns } from "./tki-qrcode.vue?vue&type=template&id=4b09126f&xlang=wxml&minapp=mpvue&"
import script from "./tki-qrcode.vue?vue&type=script&lang=js&"
export * from "./tki-qrcode.vue?vue&type=script&lang=js&"
import style0 from "./tki-qrcode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b09126f')) {
      api.createRecord('4b09126f', component.options)
    } else {
      api.reload('4b09126f', component.options)
    }
    module.hot.accept("./tki-qrcode.vue?vue&type=template&id=4b09126f&xlang=wxml&minapp=mpvue&", function () {
      api.rerender('4b09126f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tki-qrcode/tki-qrcode.vue"
export default component.exports